import { render, staticRenderFns } from "./UserFormTwoFactor.vue?vue&type=template&id=4691fe4c&scoped=true&"
import script from "./UserFormTwoFactor.vue?vue&type=script&lang=js&"
export * from "./UserFormTwoFactor.vue?vue&type=script&lang=js&"
import style0 from "./UserFormTwoFactor.vue?vue&type=style&index=0&id=4691fe4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4691fe4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4691fe4c')) {
      api.createRecord('4691fe4c', component.options)
    } else {
      api.reload('4691fe4c', component.options)
    }
    module.hot.accept("./UserFormTwoFactor.vue?vue&type=template&id=4691fe4c&scoped=true&", function () {
      api.rerender('4691fe4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserFormTwoFactor.vue"
export default component.exports